import * as React from "react";
import { HierarchyControl, HierarchyControlItem } from '../../basf-ui';
import { MapDataGroupId, MapDataSourceId, MapDataGroup, MapDataSource } from '../models/MapDataSource';
import { MAP_DATA_SORCES_DTO } from '../drafts/mapDataSources';
import { useMapStore } from "../hooks/useMapStore";
import { useHookSubscribe } from "../../react-rxjs";
import { orderBy } from "lodash";

interface ControlItem extends HierarchyControlItem<MapDataGroupId | MapDataSourceId> {
  data: MapDataGroup | MapDataSource;
}

export const DataSourceControl: React.FC = () => {
  const [items, setItems] = React.useState<ControlItem[]>([]);
  const store = useMapStore();
  const loading = useHookSubscribe(true, store.loadingDataSources$);
  const dataSources = useHookSubscribe([], store.dataSources$);
  const dataSourceId = useHookSubscribe(MapDataSourceId.HarmonizedDataset, store.dataSourceId$);

  React.useEffect(function updateControlItems() {
    setItems(orderBy(dataSources, e => e.order).map(item => ({
      id: item.id,
      name: item.name,
      data: item,
      parent: item instanceof MapDataSource ? item.groupId : undefined,
      // disabled: item.id !== MapDataSourceId.HarmonizedDataset && item.id !== MapDataGroupId.APOfficial,
    })));
  }, [dataSources]);

  const handlerChange = React.useCallback((value: number) => {
    store.dataSourceId$.next(value);
  }, [store]);

  const control = React.useMemo(() => {
    const label = "Dataset";
    return <HierarchyControl inputLarge noSelectableParent loading={loading} label={label} value={dataSourceId} items={items} onChange={handlerChange} />
  }, [dataSourceId, items, loading]);

  return control;
};
